import { Injectable } from "@angular/core";
import { Observable, } from 'rxjs';
import { HttpClient, HttpParams,HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { map } from 'rxjs/operators';
import { UserData } from '../shared/models/user.model';
import jwt_decode, { JwtPayload } from 'jwt-decode'
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
@Injectable()
export class ServiceHelper {
    constructor(private httpclient: HttpClient, private router: Router) {
    }
   
    // getUserbyntlogin(ntLogin: string): Observable<any> {
    //     let Params = new HttpParams();


        
    //     Params = Params.append("ntLogin", ntLogin)
    //     return this.httpclient.get(environment.getUserbyntlogin, { params: Params, withCredentials: true, headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })                })
    //     .pipe(map(response =>{ return response}));
    // }
   
   
    ValidateUserProfile(UserDetails: UserData): boolean {
        let profileExists: boolean = false;
        if (UserDetails != null) {
            if (UserDetails.AccessToken != undefined && UserDetails.AccessToken != null
                && UserDetails.Name != undefined && UserDetails.Name != null
                && UserDetails.NtLogin != undefined && UserDetails.NtLogin != null
                && UserDetails.Email != undefined && UserDetails.Email != null) {
                profileExists = true;
            }
        }
        return profileExists;;
    }
    isTokenExpired(token: string): boolean {
        try {
            if (token != null && token != undefined) {
                const tokenInfo = jwt_decode<JwtPayload>(token)
                let  expireDate = tokenInfo.exp as number
                const date = new Date(0);
                date.setUTCSeconds(expireDate);
                let isExpired = !(date.valueOf() > new Date().valueOf());
                return isExpired;
            } else {
                return true;
            }
        }
        catch (Error) {
            return false;
        }
    }
    GetUserNtLogin(): string {
        let userData = new UserData();
        userData = JSON.parse(localStorage.getItem("userprofile")!);
        return userData != null ? userData.NtLogin : "";
    }
    
    
    fillYearDropDown(optionsList: any[]): number {
        let currentYear = new Date().getFullYear();
        for (let i = currentYear; i >= 2019; i--) {
            optionsList.push(i);
        }
        return currentYear;
    }
}